import { render, staticRenderFns } from "./ConfianceCard.vue?vue&type=template&id=136095e5"
import script from "./ConfianceCard.vue?vue&type=script&lang=js"
export * from "./ConfianceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports